import type { MissionType, MissionTypeEditionInput } from '@wwf/sdk';
import { RAFile } from './types';

export type MissionTypeInput = MissionTypeEditionInput & {
    iconInput?: RAFile;
};

export function missionTypeToInput(record: MissionType): MissionTypeInput {
    const { icon, ...edition } = record;

    return {
        ...edition,
        iconId: icon?.id ?? null,
    };
}
